import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip, Box } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const BlogPostsTableRow = ({ item, index, perms, selectedIds, onRowCheckboxClick, onMenuOpen, page, perPage, isArabic }) => {
    const isSelected = selectedIds.includes(item.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox checked={isSelected} onClick={(event) => onRowCheckboxClick(event, item.id)} />
            </TableCell>
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic
                    ? (item?.title?.ar || item?.title?.en || '-')
                    : (item?.title?.en || item?.title?.ar || '-')
                }
            </TableCell>
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                    {(item?.categories || []).slice(0, 2).map(cat => (
                        <Chip key={cat.id} label={isArabic ? (cat.title?.ar || cat.title?.en) : (cat.title?.en || cat.title?.ar)} size="small" variant="outlined" sx={{ borderRadius: '6px' }} />
                    ))}
                </Box>
            </TableCell>
            <TableCell align="center">
                <Chip
                    label={item?.show_in_home ? (isArabic ? 'معروض' : 'Yes') : (isArabic ? 'مخفي' : 'No')}
                    size="small"
                    color={item?.show_in_home ? 'success' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {item?.created_at ? dayjs(item.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, item)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default BlogPostsTableRow;
